import { render } from "./SessionActivityChangeRequest.vue?vue&type=template&id=4fcf94c5"
import script from "./SessionActivityChangeRequest.vue?vue&type=script&lang=js"
export * from "./SessionActivityChangeRequest.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__